// extracted by mini-css-extract-plugin
export var completionBody = "_j9-2";
export var completionCard = "_j9-0";
export var completionFooter = "_j9-3";
export var completionTitle = "_j9-1";